import type { SxProps } from '@mui/material'
import TextField, { type TextFieldProps } from '@mui/material/TextField'
import { styled } from '@mui/system'
import React, { useMemo } from 'react'

import { LuneTheme } from '../theme'

import FieldValidationError from './FieldValidationError'
import { getInputBaseStyles } from './InputNew'

const TextareaNew = ({
    id,
    name,
    disabled,
    error,
    placeholder,
    onChange,
    onBlur,
    onFocus,
    className,
    wide,
    rows,
    maxRows,
    autofocus,
    inputRef,
    sx,
    singleLine,
    ...rest
}: {
    id?: string
    disabled?: boolean
    error?: string | boolean
    placeholder?: string
    name?: string
    onChange?: React.ChangeEventHandler<HTMLTextAreaElement>
    onBlur?: React.FocusEventHandler<HTMLTextAreaElement>
    onFocus?: React.FocusEventHandler<HTMLTextAreaElement>
    value?: string
    className?: string
    wide?: boolean
    rows?: number
    maxRows?: number
    autofocus?: boolean
    inputRef?: React.Ref<any>
    sx?: SxProps
    singleLine?: boolean
    InputProps?: TextFieldProps['InputProps']
}) => {
    const { spacing } = LuneTheme

    const StyledTextarea = useMemo(
        () =>
            styled(TextField)(
                LuneTheme.unstable_sx({
                    ...(getInputBaseStyles('md', wide, '.MuiSelect-select') as Record<
                        string,
                        unknown
                    >),
                    fieldset: {
                        border: 'none',
                    },
                    '.MuiSelect-select': {
                        display: 'flex',
                        alignItems: 'center',
                        padding: 0,
                        paddingRight: spacing(3),
                    },
                }),
            ),
        [wide],
    )

    return (
        <>
            <StyledTextarea
                multiline={!singleLine}
                maxRows={maxRows}
                rows={rows}
                autoFocus={autofocus}
                inputRef={inputRef}
                {...(id && { id })}
                {...(placeholder && { placeholder })}
                {...(onChange && { onChange })}
                {...(onFocus && { onFocus })}
                {...(onBlur && { onBlur })}
                {...(name && { name })}
                className={`${className} ${disabled ? 'disabled' : error ? 'error' : ''}`}
                disabled={disabled ?? false}
                sx={sx}
                {...rest}
            />
            {typeof error === `string` && <FieldValidationError error={error} />}
        </>
    )
}

export default TextareaNew
